import PaginatedTable from '../../components/ui/PaginatedTable';
import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function VendorPaymentReports() {
  const [summary, setSummary] = useState({
    invoiced: 0,
    received: 0,
    pending: 0,
  });

  const [history, setHistory] = useState([]);
  const [error,setError]=useState('');

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    try {
    const res = await fetch("/api/vendor/payment-report", {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") {
      setSummary(data.summary);
      setHistory(data.history);
    }else{throw Error(data.message||'Unable to load payment report');
    }
    }catch(e){setError(e.message);}
  };
  return (
    <DashboardLayout>
      <div className="space-y-8">
        {error&&<p role="alert" className="rounded-xl bg-red-400/10 p-3 text-red-200">{error}</p>}
        <div>
          <h1 className="text-2xl font-serif">Payment Reports</h1>
          <p className="text-sm text-gray-400">
            Invoice payments & settlement status
          </p>
        </div>

        <section className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <SummaryCard
            label="Total Payable"
            value={`₹${summary.invoiced.toLocaleString()}`}
          />

          <SummaryCard
            label="Payments Received"
            value={`₹${summary.received.toLocaleString()}`}
            green
          />

          <SummaryCard
            label="Outstanding"
            value={`₹${summary.pending.toLocaleString()}`}
            danger
          />
        </section>

        <section className="rounded-2xl bg-white/5 border border-white/10 p-6">
          <h3 className="font-serif text-lg mb-4">Payment History</h3>

          <PaginatedTable className="w-full text-sm">
            <thead className="text-gray-400">
              <tr>
                <th className="text-left py-2">PO Number</th>
                <th>Date</th>
                <th>Status</th>
                <th className="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {history.map((p) => (
                <tr key={p.id} className="border-t border-white/10">
                  <td className="py-3">{p.po}</td>

                  <td className="text-center">
                    {new Date(
                      p.status === "Paid" ? p.date : p.due_date,
                    ).toLocaleDateString()}
                  </td>

                  <td className="text-center">
                    <PaymentBadge status={p.status} />
                  </td>

                  <td className="text-right text-amber-400">
                    ₹{Number(p.amount).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </PaginatedTable>
        </section>
      </div>
    </DashboardLayout>
  );
}

function SummaryCard({ label, value, danger, green }) {
  return (
    <div
      className={`rounded-2xl p-6 border ${
        danger
          ? "bg-red-500/10 border-red-500/30 text-red-400"
          : green
            ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-400"
            : "bg-white/5 border-white/10"
      }`}
    >
      <p className="text-xs text-gray-400 tracking-widest uppercase">{label}</p>
      <h2 className="mt-3 text-3xl font-serif">{value}</h2>
    </div>
  );
}

function PaymentBadge({ status }) {
  const styles =
    status === "Paid"
      ? "bg-emerald-500/20 text-emerald-400"
      : "bg-amber-400/20 text-amber-400";

  return (
    <span className={`px-3 py-1 rounded-full text-xs ${styles}`}>{status}</span>
  );
}
